const Header=()=>{
    return(
        <div className="header">
            <p className="headertitle">Best Book To Read</p>
        </div>
    )
}
export default Header;